export default __webpack_public_path__ + "static/celebrand-logo-63613f3a28726c35f0f3d64c89b39e0b.png";